module.exports = __webpack_public_path__ + "img/PPMP4.ff0b805f.png";